export default function Footer() {
  return (
    <div className="foot">
      <a href="https://koderspedia.com/" target="_blank" rel="noopener noreferrer">
        © 2026 <strong>KodersPedia</strong> · All Rights Reserved · +1 650-284-0473
      </a>
    </div>
  );
}
